import { Component } from '@angular/core';

import { EmailSettingsService } from './email-settings.service';

@Component({
  selector: 'email-settings',
  template: require('./email-settings.component.html'),
  styles: [require('./email-settings.component.scss')],
  providers: [EmailSettingsService],
})
export class EmailSettingsComponent {

  constructor(private service: EmailSettingsService) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-settings/email-settings.component.ts